export default __webpack_public_path__ + "static/media/empty_cart.29f0fe95.svg";